import React, { PropTypes, Component } from 'react'
import cx from 'classnames'

import './PromoCodeForm.scss'
import InputControl from 'components/InputControl'

class PromoCodeForm extends Component {
  constructor (props) {
    super(props)

    this.redeem = this.redeem.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)

    this.state = {
      code: '',
      error: '',
      touched: false,
      active: false,
      edited: false
    }
  }

  componentDidMount () {
    const { initialValues } = this.props
    if (initialValues.code) {
      this.setState({
        code: initialValues.code
      }, this.redeem)
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.promoCode !== prevProps.promoCode) {
      this.promoCodeDidUpdate()
    }
  }

  promoCodeDidUpdate () {
    const { promoCode } = this.props
    // We can't simply check for truthy/falsy values because promoCode.valid === undefined does not imply that the code is invalid.
    if (promoCode.valid === false) {
      const error = new Error(promoCode.error)
      this.displayError(error)
    } else if (promoCode.valid === true) {
      this.setState({
        edited: false,
        error: ''
      })
    }
  }

  displayError (e) {
    this.setState({
      error: e.message
    })
  }

  clearError () {
    this.setState({
      error: ''
    })
  }

  displayRequiredError () {
    const error = new Error('Required')
    this.displayError(error)
  }

  redeem () {
    const { code } = this.state

    if (code) {
      this.props.redeem(code)
    } else {
      this.displayRequiredError()
    }

    this.setState({ touched: true })
  }

  handleChange (e) {
    this.clearError()

    const { value: code } = e.target
    this.setState({
      code,
      edited: true,
      error: ''
    })
  }

  handleFocus (e) {
    this.setState({
      active: true
    })
  }

  handleBlur (e) {
    this.setState({
      active: false,
      touched: true
    })
  }

  handleKeyPress (e) {
    const ENTER = 'Enter'
    if (e.key === ENTER) {
      this.redeem()
    }
  }

  render () {
    const { redeeming, promoCode, disabled } = this.props
    const { code, edited, ...meta } = this.state

    const label = 'Código promocional'
    const type = 'text'
    const input = {
      name: 'code',
      value: code,
      disabled: disabled || redeeming,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyPress: this.handleKeyPress
    }

    const inputControlProps = {
      label,
      type,
      meta: { ...meta },
      input
    }

    const showSuccessButton = !edited && promoCode.valid === true
    const buttonClassName = cx(
      'btn btn-lg btn-block',
      {
        'btn-default': !showSuccessButton,
        'btn-success': showSuccessButton
      }
    )
    const buttonCopy = showSuccessButton
      ? 'Promoción aplicada'
      : 'Aplicar promoción'
    const buttonDisabled = disabled || redeeming || showSuccessButton

    return (
      <div className='PromoCodeForm'>
        <div>
          <InputControl {...inputControlProps} />
        </div>

        <div>
          <button
            className={buttonClassName}
            type='button'
            onClick={this.redeem}
            disabled={buttonDisabled}
            >
            {buttonCopy}
          </button>
        </div>
      </div>
    )
  }
}

PromoCodeForm.propTypes = {
  redeem: PropTypes.func.isRequired,
  redeeming: PropTypes.bool,
  promoCode: PropTypes.shape({
    valid: PropTypes.bool,
    error: PropTypes.string
  }).isRequired,
  disabled: PropTypes.bool,
  initialValues: PropTypes.shape({
    code: PropTypes.string
  })
}
PromoCodeForm.defaultProps = {
  redeeming: false,
  disabled: false,
  initialValues: {}
}

export default PromoCodeForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/SecondTimeBookingConfirmation/components/PromoCodeForm/PromoCodeForm.js